module.exports = __webpack_public_path__ + "static/media/aboutme.b581827a.jpeg";